export class PageNotReady extends Error {}

export class ErrorAlreadySent extends Error {}
